import { render, staticRenderFns } from "./ShadowBtn4.vue?vue&type=template&id=8930b828&scoped=true"
import script from "./ShadowBtn4.vue?vue&type=script&lang=js"
export * from "./ShadowBtn4.vue?vue&type=script&lang=js"
import style0 from "./ShadowBtn4.vue?vue&type=style&index=0&id=8930b828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8930b828",
  null
  
)

export default component.exports